import { createAsyncThunk } from "@reduxjs/toolkit";
import type { AxiosProgressEvent } from "axios";
import interceptor from "../API/axios";

export const getProductsList = createAsyncThunk("/product", async () => {
  try {
    const response = await interceptor.get("/estimate/products");
    return response;
  } catch (error: any) {
    return error.response ?? error;
  }
});
export const getEstimateAccountList = createAsyncThunk(
  "estimate/listByAccount",
  async ({
    limit,
    offset,
    panel,
    configId
  }: Record<string, number | any>) => {
    try {
      // const state = payload.getState();
      // const { selectedUsers } = state.auth;
      const panelValue = panel == "pending-roi" ? -1 : panel
      const response = await interceptor.get(`estimate/listByAccount?limit=${limit}&offset=${offset}&accountId=${panelValue}&configId=${configId}`);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const postLogin = createAsyncThunk(
  "user/login",
  async (payload: any) => {
    try {
      const response = await interceptor.post("/user/login", payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const postForget = createAsyncThunk(
  "user/forgotpassword",
  async (payload: any) => {
    try {
      const response = await interceptor.post("/user/forgotpassword", payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const postresetpassword = createAsyncThunk(
  "user/resetpassword",
  async (payload: any) => {
    try {
      const response = await interceptor.post("/user/resetpassword", payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const validateUniqueCode = createAsyncThunk(
  "user/validateuniquecode",
  async (payload: any) => {
    try {
      const response = await interceptor.post(
        "/user/validateuniquecode",
        payload
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const getUserProfile = createAsyncThunk("user/profile", async () => {
  try {
    const response = await interceptor.get(`/user/profile`);
    return response;
  } catch (error: any) {
    return error.response ?? error;
  }
});


export const getPartnerProfile = createAsyncThunk("user/profile/partner", async (userId?: any, partnerId?: any) => {
  try {
    const response = await interceptor.get(userId ? `/user/profile?userId=${userId}` : partnerId ? `/user/profile?partnerId=${partnerId}` : `/user/profile`);
    return response;
  } catch (error: any) {
    return error.response ?? error;
  }
});

export const postEditProfile = createAsyncThunk(
  "user/updateProfile",
  async (payload: any) => {
    try {
      const response = await interceptor.post("/user/updateProfile", payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const updateUserGuide = createAsyncThunk(
  "user/updateUserGuide",
  async (payload: any) => {
    try {
      const response = await interceptor.post("/user/updateProfile", payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const fetchUserList = createAsyncThunk(
  "fetch/users",
  async ({
    limit = 10,
    keyword = "",
    offset = 0,
    sortName = "id",
    direction = "asc",
    roleId = null,
    userId = "",
    isGlobalFederal = false, 
  }: Record<string, number | string | boolean | null>) => {
    try {
      const params = new URLSearchParams({
        limit: String(limit),
        offset: String(offset),
        sort: String(sortName),
        direction: String(direction),
        search: String(keyword),
      });
      if (roleId) {
        params.append("roleId", String(roleId));
      } else if (isGlobalFederal && userId) {
        params.append("federalId", String(userId));
      }

      const response = await interceptor.get(`/user/list?${params.toString()}`);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);


export const updateActiveDeactiveUser = createAsyncThunk(
  "user/activeDeactive",
  async (payload: any) => {
    const response = await interceptor.post("/user/activedeactive", payload);
    return response;
  }
);

export const createUserAction = createAsyncThunk(
  "user/sendInvite",
  async (payload: any) => {
    try {
      const response = await interceptor.post("/user/sendInvite", payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const UpdateUserAction = createAsyncThunk(
  "user/updateRole",
  async (payload: any) => {
    try {
      const response = await interceptor.post("/user/updateRole", payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);
export const resendInvite = createAsyncThunk(
  "user/reSendInvite",
  async (payload: any) => {
    try {
      const response = await interceptor.post("/user/reSendInvite", payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

// configuration actions

export const fetchConfig: any = createAsyncThunk(
  "config/configuration?configType=1",
  async () => {
    try {
      const response = await interceptor.get(
        "/config/configuration?configType=1"
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);
export const fetchFederalConfig: any = createAsyncThunk(
  "config/configuration?configType=2",
  async () => {
    try {
      const response = await interceptor.get(
        "/config/configuration?configType=2"
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);
export const fetchConfig2: any = createAsyncThunk(
  "config/configuration?configType=1",
  async (estId: any) => {
    try {
      const response = await interceptor.get(
        `config/configurationByEstimate?configType=1&estId=${estId}`
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);
export const fetchFedConfig2: any = createAsyncThunk(
  "config/configuration?configType=2",
  async (estId: any) => {
    try {
      const response = await interceptor.get(
        `config/configurationByEstimate?configType=2&estId=${estId}`
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);
export const fetchCurrencyList: any = createAsyncThunk(
  "estimate/roiCurrencyList",
  async () => {
    try {
      const response = await interceptor.get(
        "/estimate/roiCurrencyList"
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const postConfig: any = createAsyncThunk(
  "config/updateconfiguration",
  async (payload: any) => {
    try {
      const response = await interceptor.post(
        "/config/updateconfiguration",
        payload
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

// Estimate async thunk
export const getEstimate = createAsyncThunk(
  "estimate/list",
  async ({
    limit,
    offset,
    keyword,
    sort,
    direction,
    estimateType,
    role,
    configId,
    parentType
  }: Record<string, number | any>, payload: any) => {
    try {
      const state = payload.getState();
      const { selectedUsers } = state.auth;
      if (role === 5) {
        const response = await interceptor.get(selectedUsers > 2 ? `/existing/estimate/list?limit=${limit}&offset=${offset}&search=${keyword}&sort=${sort}&direction=${direction}&configId=${configId}` : `/estimate/list?limit=${limit}&offset=${offset}&search=${keyword}&sort=${sort}&direction=${direction}&estimateType=partner`);
        return response;
      }
      if (parentType == 2) {
        const response = await interceptor.get(selectedUsers > 2 ? `/estimate/getArchivedEstimatesByUserId?limit=${limit}&offset=${offset}&search=${keyword}&sort=${sort}&direction=${direction}&configId=${configId}
` : `/estimate/getArchivedEstimatesByUserId?limit=${limit}&offset=${offset}&search=${keyword}&sort=${sort}&direction=${direction}&configId=${configId}`);
        return response;
      }
      if (role === 5 || estimateType != "internal") {
        const response = await interceptor.get(selectedUsers > 2 ? `/existing/estimate/list?limit=${limit}&offset=${offset}&search=${keyword}&sort=${sort}&direction=${direction}&estimateType=${ ![5,6].includes(role) ? estimateType : 'partner'}` : `/estimate/list?limit=${limit}&offset=${offset}&search=${keyword}&sort=${sort}&direction=${direction}&estimateType=${![5,6].includes(role) ? estimateType : 'partner'}`);
        return response;
      }
      else {
        const response = await interceptor.get(selectedUsers > 2 ? `account/listByEstimate?limit=${limit}&offset=${offset}&search=${keyword}&sort=${sort}&direction=${direction}&configId=${configId}` : `account/listByEstimate?limit=${limit}&offset=${offset}&search=${keyword}&sort=${sort}&direction=${direction}&configId=${configId}&estimateType=${estimateType}`);
        return response;
      }
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const getPartnerCustomer: any = createAsyncThunk(
  "estimate/customers",
  async ({ name }: Record<string, string>) => {
    try {
      const response = await interceptor.get(
        `/estimate/customers?name=${name}`
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const getCustomer: any = createAsyncThunk(
  "account/list",
  async ({ name, isFederalGlobalUser }: Record<string, string>) => {
    try {
      const response = await interceptor.get(
        `/account/list?search=${name}&configId=${isFederalGlobalUser ? 2 : 1}`
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const stepperAPIAction: any = createAsyncThunk(
  "estimate/stepperAPIAction",
  async (payload: any) => {
    try {
      const { method, endPoint, body } = payload;
      const response: any = await interceptor[method](
        `/estimate/${endPoint}`,
        body
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const stepperAPIExisting: any = createAsyncThunk(
  "existing/estimate/stepperAPIAction",
  async (payload: any) => {
    try {
      const { method, endPoint, body } = payload;
      const response: any = await interceptor[method](
        `/existing/estimate/${endPoint}`,
        body
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const getEstimateDetail: any = createAsyncThunk(
  "estimate/details",
  async (id: number, payload: any) => {
    try {
      const state = payload.getState();
      const { selectedUsers } = state.auth;
      const { estimatesType, isPending } = state.estimate
      const response = await interceptor.get(`${selectedUsers > 2 ? `/existing/estimate/details?estId=${id}&businessType=${selectedUsers}&estimateType=${isPending ? "internal" : estimatesType}` : `/estimate/details?estId=${id}&estimateType=${isPending ? "internal" : estimatesType}`}`);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const getCalculationData: any = createAsyncThunk(
  "/estimate/calculation",
  async (payload: any) => {
    try {
      const selectedUsers = payload.selectedUser;
      const response = await interceptor[payload.method](
        `${(selectedUsers === 3 || selectedUsers == 4) ? `/existing/estimate/${payload.endPoint}` : `/estimate/${payload.endPoint}`}`
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const saveEstimate = createAsyncThunk(
  "estimate/save",
  async (payload: any) => {
    try {
      const response = await interceptor.put(`/estimate/save`, payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const generateROIReport = createAsyncThunk(
  "estimate/roicalculation",

  async (body: any, payload: any) => {
    try {
      if (!body) {
        return payload.rejectWithValue({
          data: { message: "PDF generation details are missing." },
        });
      }

      const state = payload.getState();
      const { selectedUsers } = state.auth;
      const response = await interceptor.post(`${selectedUsers > 2 ? `/existing/estimate/roicalculation` : `/estimate/roicalculation`}`, body);
      return response;
    } catch (error: any) {
      return payload.rejectWithValue(
        error.response ?? { data: { message: error.message ?? "Unable to generate the ROI report." } }
      );
    }
  }
);

export const uploadGeneratedPdf = createAsyncThunk(
  "estimate/pdf-generated",
  async (
    {
      estimateId,
      pdf,
      fileName,
      generationTicket,
      onUploadProgress,
    }: {
      estimateId: number | string;
      pdf: Blob;
      fileName: string;
      generationTicket: string;
      onUploadProgress?: (percent: number | null) => void;
    },
    payload: any
  ) => {
    try {
      const formData = new FormData();
      formData.append("estimateId", String(estimateId));
      formData.append("generationTicket", generationTicket);
      formData.append("pdf", pdf, fileName);

      const handleUploadProgress = (event: AxiosProgressEvent): void => {
        const loaded = Number(event.loaded);
        const total = Number(event.total);

        if (
          !Number.isFinite(loaded) ||
          !Number.isFinite(total) ||
          total <= 0
        ) {
          onUploadProgress?.(null);
          return;
        }

        const percent =
          loaded >= total
            ? 100
            : Math.max(0, Math.min(99, Math.floor((loaded / total) * 100)));
        onUploadProgress?.(percent);
      };

      return await interceptor.post("/estimate/pdf-generated", formData, {
        onUploadProgress: handleUploadProgress,
      });
    } catch (error: any) {
      return payload.rejectWithValue(
        error.response ?? { data: { message: error.message ?? "Unable to save the generated PDF." } }
      );
    }
  }
);

export const cloneTheEstimate = createAsyncThunk(
  "estimate/clone",
  async (payload: any, _: any) => {
    try {
      const state = _.getState();
      const { selectedUsers } = state.auth;

      const url = selectedUsers > 2 ? `/existing/estimate/clone` : `/estimate/clone`;
      const response = await interceptor.post(url, {
        estimateId: payload.id,
        estimateName: payload.estName.replace(/\s\s+/g, " ").trim(),
      });
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const downloadEstimate = createAsyncThunk(
  "estimate/download",
  async (id: any, payload: any) => {
    try {
      const state = payload.getState();
      const { selectedUsers } = state.auth;
      const url = selectedUsers > 2 ? `/existing/estimate/download` : `/estimate/download`;

      const response = await interceptor.post(url, {
        estId: id,
      });
      return response;
    } catch (error: any) {
      return payload.rejectWithValue(
        error.response ?? { data: { message: error.message ?? "Unable to download the ROI report." } }
      );
    }
  }
);
export const deleteEstimate = createAsyncThunk("estimate/delete",
  async (id: any) => {
    try {
      const response = await interceptor.post(`/estimate/delete`, {
        estimateId: id,
      });
      return response;
    }
    catch (error: any) {
      return error.response ?? error;
    }
  }
);
export const fetchSeeMoreEstimate = createAsyncThunk(
  "estimate/more",
  async (payload: any) => {
    try {
      const { id, offset, estimatesType }: any = payload;
      const response = await interceptor.get(
        `/existing/estimate/more?${(estimatesType == "internal" || id == -1) ? `accountId` : `customerId`}=${id}&limit=5&offset=${offset}&estimatesType=${estimatesType}`
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const updateProductCombination: any = createAsyncThunk(
  "estimate/product",
  async (payload: any, User?: any) => {
    try {
      if (payload) {
        const state = User.getState()
        const { selectedUsers } = state.auth
        const response = await interceptor.patch(
          (selectedUsers === 3 || selectedUsers === 4)
            ? "existing/estimate/product"
            : "/estimate/product",
          payload
        );
        return response;
      }
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const fetchRoles: any = createAsyncThunk(
  "role/list",
  async () => {
    try {
      const response = await interceptor.get(`/role/list`);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const fetchPatnerUserList = createAsyncThunk(
  "fetch/partner-users",
  async ({
    limit = 10,
    offset = 0,
    sortName = "id",
    direction = "asc",
    id = null
  }: Record<string, number | string | boolean | null>) => {
    try {
      const response = await interceptor.get(
        `/user/list?limit=${limit}&offset=${offset}&sort=${sortName}&direction=${direction}&partnerId=${id}`
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);


export const fetchPartnerPdf: any = createAsyncThunk('/partner/pdf', async (id: number | string) => {
  try {
    const response = await interceptor.get(
      `/partner/pdf?partnerId=${id}`
    );
    return response;
  } catch (error: any) {
    return error.response ?? error;
  }
});

export const postPartnerPdf: any = createAsyncThunk('post/partner/pdf', async (body: any) => {
  try {
    const response = await interceptor.post(
      `/partner/pdf`, body
    );
    return response;
  } catch (error: any) {
    return error.response ?? error;
  }
});

export const uploadPicture: any = createAsyncThunk('user/upload', async (body: any) => {
  try {
    const response = await interceptor.post(
      `/user/upload`, body
    );
    return response;
  } catch (error: any) {
    return error.response ?? error;
  }
})
// Currency code 
export const fetchAvCurrencyList: any = createAsyncThunk(
  "estimate/currencyList",
  async () => {
    try {
      const response = await interceptor.get(
        "estimate/currencyList"
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const fetchSelCurrencyList: any = createAsyncThunk(
  "api/estimate/roiCurrencyList",
  async () => {
    try {
      const response = await interceptor.get(
        "estimate/roiCurrencyList"
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const roiCurrencyUpdate = createAsyncThunk(
  "estimate/roiCurrencyUpdate",
  async (payload: any) => {
    try {
      const response = await interceptor.post("/estimate/roiCurrencyUpdate", payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);
export const getContact: any = createAsyncThunk(
  "account/contacts",
  async ({ name, userId }: Record<string, string>) => {
    try {
      const response = await interceptor.get(
        `/account/contacts?accountId=${userId}&search=${name}`
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);
export const getOpportunity: any = createAsyncThunk(
  "account/opportunity",
  async ({ name, userId }: Record<string, string>) => {
    try {
      const response = await interceptor.get(
        `account/opportunity?search=${name}&accountId=${userId}`
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const ArrangeCurrencies = createAsyncThunk(
  "estimate/roiCurrencyUpdate",
  async (payload: any) => {
    try {
      const response = await interceptor.post("/estimate/roiCurrencyUpdate", payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);


export const getSubProductList = createAsyncThunk(
  "config/reductionConfiguration",
  async () => {
    try {
      const response = await interceptor.get(`config/reductionConfiguration`);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);


export const postSubProductList = createAsyncThunk(
  "/config/reductionConfiguration",
  async (payload: any) => {
    try {
      const response = await interceptor.post("config/reductionConfiguration", payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

// Estimate by User

export const ConfirmUserTransfer = createAsyncThunk(
  "/estimate/transferRoiToNewUser",
  async (payload: any) => {
    try {
      const response = await interceptor.post("estimate/transferRoiToNewUser", payload);
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);

export const ListByUsers = createAsyncThunk(
  "user/list",
  async (payload:any) => {
    try {
      const response = await interceptor.get(
        `user/list?sort=isActive&limit=20&offset=0&direction=DESC&isActive=true&search=${payload}`
      );
      return response;
    } catch (error: any) {
      return error.response ?? error;
    }
  }
);
